import data from '@emoji-mart/data';
import { init, SearchIndex } from 'emoji-mart';

init({ data });
const emojiSearchIndex = SearchIndex;

export { emojiSearchIndex };
//# sourceMappingURL=emoji_data.js.map
